export default { sha: '5190f7f92b10e201189cd7830a8e958985bb099b', buildNumber: 'undefined' }
